export default __webpack_public_path__ + "static/media/step2.f7fba988.png";